import React from "react";

const Blog = () => {
  return (
    <div>
      <div>
        <h1>Coming Soon ...</h1>
      </div>
    </div>
  );
};

export default Blog;
